module.exports = __webpack_public_path__ + "img/mz-logo.e62da783.png";